import React from "react";
import { translate } from "../../../Services/translation";
import { DynamicWidgets } from "react-instantsearch";
import { RefinementPanel } from "./Panel";
import ColorRefinementList from "./ColorRefinementList";
import CustomRefinementList from "./CustomRefinementList";
import SizeRefinementList from "./SizeRefinementList";
import CustomHierarchicalMenu from "./CustomHierarchicalMenu";
import { FiltersProps } from "./types/FiltersProps";

const Filters = ({ disabledFilters = [], openedOnInit }: FiltersProps) => {
  const filteredDisabledFilters = disabledFilters.filter((item) => item !== "");

  return (
    <DynamicWidgets maxValuesPerFacet={100}>
      <CustomRefinementList
        attribute="brand"
        searchable={true}
        searchablePlaceholder={translate("algolia.filters.brand.placeholder")}
        showMore={true}
        disabledFilters={filteredDisabledFilters}
        limit={10}
        showMoreLimit={40}
        openedOnInit={false}
      />
      <SizeRefinementList
        attribute="filterSizesClothing"
        showMore={true}
        disabledFilters={filteredDisabledFilters}
        limit={20}
        showMoreLimit={40}
        openedOnInit={false}
      />
      <SizeRefinementList
        attribute="filterSizesShoe"
        showMore={true}
        disabledFilters={filteredDisabledFilters}
        limit={20}
        showMoreLimit={40}
        openedOnInit={false}
      />
      <SizeRefinementList
        attribute="filterSizesTrouser"
        showMore={true}
        disabledFilters={filteredDisabledFilters}
        limit={20}
        showMoreLimit={40}
        openedOnInit={false}
      />
      <ColorRefinementList
        attribute="filterColor"
        showMore={true}
        disabledFilters={filteredDisabledFilters}
        limit={20}
        showMoreLimit={40}
        openedOnInit={false}
      />
      <RefinementPanel
        attribute="categories.lvl0"
        disabledFilters={filteredDisabledFilters}
        openedOnInit={openedOnInit}
      >
        <CustomHierarchicalMenu
          attributes={["categories.lvl0", "categories.lvl1", "categories.lvl2"]}
          showMore={true}
          limit={20}
          showMoreLimit={40}
        />
      </RefinementPanel>
    </DynamicWidgets>
  );
};

export default Filters;
